var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05544 0.717388C9.36673 -0.178172 10.6333 -0.178173 10.9446 0.717387L12.5929 5.45943C12.7302 5.8545 13.0989 6.12237 13.5171 6.1309L18.5364 6.23318C19.4843 6.2525 19.8757 7.45704 19.1202 8.02985L15.1196 11.0629C14.7863 11.3156 14.6455 11.749 14.7666 12.1493L16.2204 16.9546C16.4949 17.8621 15.4703 18.6065 14.692 18.065L10.5712 15.1975C10.2279 14.9586 9.77214 14.9586 9.42882 15.1975L5.30799 18.065C4.52975 18.6065 3.5051 17.8621 3.77965 16.9546L5.23342 12.1493C5.35454 11.749 5.21371 11.3156 4.88042 11.0629L0.879825 8.02985C0.124293 7.45704 0.515672 6.2525 1.4636 6.23318L6.48291 6.1309C6.90108 6.12237 7.26978 5.8545 7.4071 5.45943L9.05544 0.717388Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.53dd683eb9aa457ab7def5ba8f50da03.svg";
export { ForwardRef as ReactComponent };